import {
  SCROLL_TO_RESULTADO_ID,
  ScrollableFieldsConfig,
} from '@mchat-rf/consulta-seguimento/hooks/useConsultaSeguimentoAutoScroll'
import { SimNaoEnum } from 'components/form'
import { isEmpty } from 'util/checks'

import { ConsultaSeguimentoPergunta05Model } from './model-consultaSeguimentoPergunta05'
import {
  hasPergunta05ExemplosFalhouAnySim,
  hasPergunta05ExemplosPassouAnySim,
  isPergunta05ExemplosFalhouAllFilled,
  isPergunta05ExemplosFalhouAllNao,
  isPergunta05ExemplosPassouAllNao,
} from './utils-consultaSeguimentoPergunta05'

export const PERGUNTA_05_SCROLL_CONFIG: ScrollableFieldsConfig<ConsultaSeguimentoPergunta05Model> = {
  PERGUNTA_05_HEADER: {
    scrollConditions: [
      {
        if: (value) => value === SimNaoEnum.SIM,
        scrollTo: 'PERGUNTA_05_EXEMPLOS',
      },
      {
        if: (value) => value === SimNaoEnum.NAO,
        scrollTo: SCROLL_TO_RESULTADO_ID,
      },
    ],
  },
  PERGUNTA_05_EXEMPLOS: {
    scrollConditions: [
      {
        if: (value, allValues) =>
          (isPergunta05ExemplosPassouAllNao(value) || hasPergunta05ExemplosPassouAnySim(value)) &&
          isPergunta05ExemplosFalhouAllFilled(allValues) &&
          hasPergunta05ExemplosFalhouAnySim(allValues),
        scrollTo: 'PERGUNTA_05_DUAS_VEZES_POR_SEMANA',
      },
      {
        if: (value, allValues) =>
          isPergunta05ExemplosPassouAllNao(value) &&
          isPergunta05ExemplosFalhouAllFilled(allValues) &&
          isPergunta05ExemplosFalhouAllNao(allValues),
        scrollTo: SCROLL_TO_RESULTADO_ID,
      },
      {
        if: (value, allValues) =>
          hasPergunta05ExemplosPassouAnySim(value) &&
          isPergunta05ExemplosFalhouAllFilled(allValues) &&
          isPergunta05ExemplosFalhouAllNao(allValues),
        scrollTo: SCROLL_TO_RESULTADO_ID,
      },
    ],
    isList: true,
    dependsOn: 'PERGUNTA_05_HEADER',
  },
  PERGUNTA_05_DUAS_VEZES_POR_SEMANA: {
    scrollConditions: [
      {
        if: (value) => !isEmpty(value),
        scrollTo: SCROLL_TO_RESULTADO_ID,
      },
    ],
    dependsOn: 'PERGUNTA_05_EXEMPLOS',
  },
}
